import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const MetaAdsWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 34"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <path
          fill="#fff"
          d="M8.757 18.518c0 .908.198 1.605.456 2.026.339.553.844.787 1.359.787.664 0 1.272-.167 2.443-1.8.938-1.308 2.043-3.145 2.787-4.297l1.26-1.95c.874-1.356 1.887-2.862 3.048-3.883.948-.834 1.97-1.297 3-1.297 1.728 0 3.373 1.01 4.633 2.903 1.378 2.074 2.048 4.685 2.048 7.38 0 1.603-.314 2.78-.847 3.71-.515.9-1.518 1.798-3.207 1.798v-2.564c1.446 0 1.807-1.34 1.807-2.872 0-2.185-.506-4.609-1.618-6.34-.79-1.23-1.813-1.98-2.94-1.98-1.217 0-2.197.926-3.298 2.577-.586.877-1.187 1.946-1.862 3.152l-.742 1.327c-1.493 2.668-1.871 3.276-2.617 4.279-1.308 1.756-2.425 2.421-3.895 2.421-1.745 0-2.847-.761-3.53-1.909-.558-.935-.832-2.162-.832-3.56l2.547.092Z"
        />
        <path
          fill="#fff"
          d="M8.218 11.188c1.167-1.814 2.853-3.084 4.785-3.084 1.12 0 2.232.334 3.395 1.291 1.27 1.046 2.625 2.768 4.315 5.606l.606 1.019c1.463 2.457 2.296 3.72 2.783 4.317.626.765 1.065.994 1.635.994 1.446 0 1.806-1.34 1.806-2.872l2.247-.072c0 1.603-.313 2.78-.846 3.71-.515.9-1.519 1.798-3.207 1.798-1.05 0-1.98-.23-3.008-1.208-.79-.75-1.715-2.084-2.426-3.283l-2.115-3.561c-1.06-1.788-2.034-3.12-2.597-3.724-.606-.649-1.385-1.433-2.629-1.433-1.006 0-1.86.712-2.575 1.801l-2.17-1.299Z"
        />
        <path
          fill="#fff"
          d="M12.963 10.686c-1.006 0-1.86.712-2.576 1.801-1.01 1.538-1.63 3.83-1.63 6.031 0 .908.198 1.605.456 2.026L7.04 21.986c-.557-.935-.831-2.162-.831-3.56 0-2.542.692-5.192 2.008-7.238 1.168-1.814 2.853-3.084 4.786-3.084l-.041 2.582Z"
        />
      </g>
      <defs>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-5"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_113094" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_113094" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
